import getPointIdFromStorage from '@/services/getPointId'
import API from '@/services/api'
import handleError from '@/services/handleError'
import { captureException } from '@/errors'

let methodUsedToPointId

export default function saveBatteryStatus(user, position, uuid) {
  try {
    const device = user.devices.find(device => device?.uuid === uuid)
    const { id, type } = getPointIdFromStorage()

    if (device === undefined || device === null) {
      return
    }

    if (methodUsedToPointId && methodUsedToPointId !== type && methodUsedToPointId != 'geolocation') {
      return
    }
    methodUsedToPointId = type

    const havePointId = Boolean(
      device.point_ids && Array.isArray(device.point_ids) && device.point_ids.some(pointId => pointId === id)
    )

    const haveLocation = Boolean(
      device.locations && device.locations.some(location => location !== null && location !== undefined)
    )

    if (!device || (!havePointId && id) || (!haveLocation && position?.lng && position?.lat)) {
      sendBatteryStatus(uuid, position, id, user)
      return
    }
  } catch (error) {
    captureException(error)
  }
}

async function sendBatteryStatus(deviceId, position, pointId, user) {
  let params = {
    action: 'registration'
  }

  let batteryInfo = null
  try {
    batteryInfo = await getBatteryStatus()
    if (batteryInfo?.level) {
      params.charge = batteryInfo.level
    }
  } catch (error) {
    console.error('Failed to get battery status:', error)
  }

  if (deviceId) {
    params.device_id = deviceId
  }

  if (pointId) {
    params.point_id = pointId
  }

  if (position?.lat && position?.lng) {
    params.lat = position.lat
    params.long = position.lng
  }
  if (position?.precision) {
    params.precision = parseInt(position.precision)
  }
  try {
    const response = await API.put('battery/save_history', params)
    if (response?.data?.success) {
      user.devices = user.devices.map(device => {
        if (device.uuid === deviceId) {
          device.action2_count += 1
          device.point_ids.push(pointId)
        }
        return device
      })
    } else {
      let error = ''
      if (response) {
        error = `Failed to save battery status: ${response}`
      } else {
        error = 'Failed to save battery status'
      }
      captureException(error)
      return
    }
    return response.data.success
  } catch (error) {
    console.error('Failed to save battery status:', error)
    handleError(error)
  }
}

async function getBatteryStatus() {
  if (typeof navigator !== 'undefined' && 'getBattery' in navigator) {
    try {
      const battery = await navigator.getBattery()

      let batteryInfo = {
        level: 0,
        charging: false,
        chargingTime: 0,
        dischargingTime: 0
      }

      if (battery.level) {
        batteryInfo.level = Number(battery.level * 100)
      }
      if (battery.charging) {
        batteryInfo.charging = battery.charging
      }
      if (battery.chargingTime) {
        batteryInfo.chargingTime = battery.chargingTime
      }
      if (battery.dischargingTime) {
        batteryInfo.dischargingTime = battery.dischargingTime
      }

      return batteryInfo
    } catch (error) {
      handleError(`Failed to retrieve battery status: ${error}`)
      return null
    }
  }
  return null
}
